import { tenantUsersFragment } from '@eluve/frontend-feature-tenants';
import { graphql } from '@eluve/graphql.tada';

import {
  baseTemplateFragment,
  sharedTemplateUserFragment,
  templateOrgsFragment,
  templateUsersFragment,
  tenantTemplateFragment,
} from '../operations';

/**
 * FRAGMENTS
 */

export const templateFragment = graphql(
  `
    fragment TemplateDetails on LlmOutputTemplates @_unmask {
      ...BaseTemplateDetails
      ...TemplateUsers
      ...TemplateOrgs
    }
  `,
  [baseTemplateFragment, templateUsersFragment, templateOrgsFragment],
);

/**
 * QUERIES
 */

export const getTenantOutputTemplatesQuery = graphql(
  `
    query getTenantOutputTemplates($tenantId: uuid!) {
      externalEhr {
        __typename
        id
        vendor
        domain
      }
      llmOutputTemplates {
        ...TemplateDetails
        variants(orderBy: { variantNumber: DESC }) {
          __typename
          outputTemplateId
          variantNumber
          isCurrentDefault
        }

        external_chart_templates {
          __typename
          id
          externalEhrId
          externalChartTemplateId
          externalChartTemplateOwnerId
        }
      }
      tenantsByPk(id: $tenantId) {
        __typename
        id
        ...TenantUsers
      }
    }
  `,
  [templateFragment, tenantUsersFragment],
);

/**
 * MUTATIONS
 */

export const shareTemplateWithUserMutation = graphql(
  `
    mutation shareTemplateWithUser(
      $templateId: uuid!
      $userId: uuid!
      $tenantId: uuid!
    ) {
      insertUsersLlmOutputTemplatesOne(
        object: {
          llmOutputTemplateId: $templateId
          userId: $userId
          tenantId: $tenantId
        }
      ) {
        ...SharedTemplateUser
      }
    }
  `,
  [sharedTemplateUserFragment],
);

export const unshareTemplateWithUserMutation = graphql(`
  mutation unshareTemplateWithUser(
    $templateId: uuid!
    $tenantId: uuid!
    $userId: uuid!
  ) {
    deleteUsersLlmOutputTemplates(
      where: {
        _and: [
          { llmOutputTemplateId: { _eq: $templateId } }
          { tenantId: { _eq: $tenantId } }
          { userId: { _eq: $userId } }
        ]
      }
    ) {
      __typename
      affectedRows
    }
  }
`);

export const updateTenantTemplateAccessMutation = graphql(
  `
    mutation setTenantLlmOutputTemplate(
      $tenantId: uuid!
      $llmOutputTemplateId: uuid!
      $isEnabled: Boolean!
    ) {
      insertTenantLlmOutputTemplatesOne(
        object: {
          tenantId: $tenantId
          llmOutputTemplateId: $llmOutputTemplateId
          isEnabled: $isEnabled
        }
        onConflict: {
          constraint: tenant_llm_output_templates_pkey
          updateColumns: [isEnabled]
        }
      ) {
        ...TenantTemplate
      }
    }
  `,
  [tenantTemplateFragment],
);
